export enum ButtonDesign {
  Default = 'Default',
  Positive = 'Positive',
  Negative = 'Negative',
  Transparent = 'Transparent',
  Emphasized = 'Emphasized'
}
